import { fields } from "@monorepo/utils/src/variables/projectsData/oikView/fields";

export const currentFilters = (): Record<string, unknown> => ({
  [fields.OIK_ID]: {},
  [fields.OIK_CODE]: {},
  [fields.OIK_NAME]: {},
  [fields.OIK_STATUS]: [],
  [fields.OIK_ARCHIVE]: {},
});
